import homepage from './images/projects/Homepage.png';
import productspage from './images/projects/Productspage.png';
import cartpage from './images/projects/Cartpage.png';
import checkoutpage from './images/projects/Checkoutpage.png';
import selleradminpanel from './images/projects/Selleradminpanel.png';
import tracker from './images/projects/Tracker.gif';
import CovidTrackerHomePage from './images/projects/CovidTrackerHomePage.PNG';
import CovidTrackerCountryPage from './images/projects/CovidTrackerCountryPage.PNG';
import CovidTrackerIndonesiaPage from './images/projects/CovidTrackerIndonesiaPage.PNG';
import CovidTrackerProvincePage from './images/projects/CovidTrackerProvincePage.PNG';
import CovidTrackerSpecificCountryPage from './images/projects/CovidTrackerSpecificCountryPage.PNG';

export const uCommerce = [
  {
    title: 'Home Page',
    image: homepage,
  },
  {
    title: 'Products Page',
    image: productspage,
  },
  {
    title: 'Cart Page',
    image: cartpage,
  },
  {
    title: 'Checkout Page',
    image: checkoutpage,
  },
  {
    title: 'Seller Admin Panel',
    image: selleradminpanel,
  },
];

export const TrackerApp = {
  title: 'Tracker App',
  image: tracker,
};

export const CovidTracker = [
  {
    title: 'Global Case Page',
    image: CovidTrackerHomePage,
  },
  {
    title: 'Country Cases Page',
    image: CovidTrackerCountryPage,
  },
  {
    title: 'Specific Country Modal',
    image: CovidTrackerSpecificCountryPage,
  },
  {
    title: 'Indonesia Case Page',
    image: CovidTrackerIndonesiaPage,
  },
  {
    title: "Indonesia's Province Cases Page",
    image: CovidTrackerProvincePage,
  },
];
